import { GenericError, } from './GenericError';
export function formatRawResponseData(data) {
    return {
        type: typeof data,
        data: JSON.stringify(data),
    };
}
/**
 * Base class for all request errors.
 */
export class RequestError extends GenericError {
    static className = 'RequestError';
    request;
    response;
    constructor(props) {
        super(props);
        this.request = props.request;
        this.response = props.response;
    }
    convertToJSON(debug) {
        return {
            ...super.convertToJSON(debug),
            request: debug ? this.request : undefined,
            response: debug ? this.response : undefined,
        };
    }
    assignJSON(json) {
        if (!super.assignJSON(json))
            return false;
        if (!json.request || typeof json.request !== 'object')
            return false;
        this.request = json.request;
        this.response = json.response;
        return true;
    }
    getStatusCode() {
        return this.response?.status;
    }
}
